// React
import React, { useState, useEffect, useCallback, Suspense } from 'react';
import { Link, useLocation } from 'react-router-dom';
// Components
import { Menu } from 'antd';
import * as Icons from '@ant-design/icons';
// Utils
import { ILeftMenuProps, RouterType } from './type';
import { urlToList } from './utils/pathTools';
import { getMenuMatches } from './utils/siderMenuUtils';

// Assets
const { SubMenu } = Menu;

/**
 * @description 左侧菜单
 * @param props props
 */
const LeftMenu = (props: ILeftMenuProps) => {
    const location = useLocation();
    /**
     * @description getSelectedMenuKeys
     */
    const getSelectedMenuKeys = useCallback(
        (pathname: string): any[] => {
            const { flatMenuKeys } = props;
            return urlToList(pathname).map((itemPath: any) =>
                getMenuMatches(flatMenuKeys, itemPath).pop(),
            );
        },
        [props],
    );

    const [selectedKeys, setSelectedKeys] = useState(() => {
        return getSelectedMenuKeys(location.pathname);
    }); // get selected keys

    useEffect(() => {
        const keys = getSelectedMenuKeys(location.pathname);
        setSelectedKeys(keys);
    }, [getSelectedMenuKeys, location.pathname]);

    /**
     * @description 获取菜单icon
     * @param icon icon
     */

    /**
     * @description 单条menu
     * @param item routerType
     */
    function renderData(item: RouterType) {
        const { child, url, name, title, icon_url, hidden } = item;
        //@ts-ignore
        const CurrentIcon = icon_url ? Icons[icon_url] : null;
        const IconModule = icon_url ? (
            <img
                src={icon_url}
                alt=""
                className="ant-pro-sider-menu-icon"
                style={{ width: '14px', height: '14px', verticalAlign: '-1px', marginRight: 10 }} />
        ) : null;
        if (hidden) {
            return null;
        }

        if (child && child.length > 0) {
            return (
                <SubMenu
                    key={item.url}
                    // icon={CurrentIcon  && <CurrentIcon />}
                    title={(
                        <>
                            <Suspense fallback={<div>Loading...</div>}>
                                {CurrentIcon ? <CurrentIcon /> : IconModule}
                            </Suspense>
                            <span className="subMenuTxt">{name || title}</span>
                        </>
                    )}
                >
                    {child.map(items => {
                        return renderData(items);
                    })}
                </SubMenu>
            );
        }
        return (
            <Menu.Item
                key={url}
                style={{ overflow: 'hidden' }}
                icon={(
                    <Suspense fallback={<div>Loading...</div>}>
                        {CurrentIcon ? <CurrentIcon /> : IconModule}
                    </Suspense>
                )}
            >
                <Link
                    className="lastMenuTxt"
                    to={url}
                >
                    {name || title}
                </Link>
            </Menu.Item>
        );
    }

    return (
        <Menu
            mode="inline"
            selectedKeys={selectedKeys}
            defaultOpenKeys={selectedKeys}
            inlineIndent={16}
            theme={props.option.menuTheme}
            style={{ overflowX: 'hidden' }}
        >
            {props.routers.map((item: RouterType) => {
                return renderData(item);
            })}
        </Menu>
    );
};

export default LeftMenu;
